<div
  class="splash"
  [class.splash--zooming]="zooming()"
  [class.splash--exiting]="exiting()"
  role="status"
  aria-live="polite"
  aria-busy="true"
  aria-label="Loading Africa Tamilcharal"
>
  <div class="splash__glow" aria-hidden="true"></div>

  <div class="splash__brand">
    <img
      class="splash__logo-img"
      src="/brand-logo.png"
      alt="Africa Tamilcharal"
      width="280"
      height="62"
      decoding="async"
    />
    <p class="splash__tagline">{{ tagline }}</p>
  </div>

  <div class="splash__book-stage" aria-hidden="true">
    <div class="splash__book">
      <div class="splash__book-spine"></div>
      <div class="splash__page splash__page--left"></div>
      <div class="splash__page splash__page--static-right"></div>
      <div class="splash__flip splash__flip--1"><span class="splash__face splash__face--front"></span><span class="splash__face splash__face--back"></span></div>
      <div class="splash__flip splash__flip--2"><span class="splash__face splash__face--front"></span><span class="splash__face splash__face--back"></span></div>
      <div class="splash__flip splash__flip--3"><span class="splash__face splash__face--front"></span><span class="splash__face splash__face--back"></span></div>
      <div class="splash__flip splash__flip--4"><span class="splash__face splash__face--front"></span><span class="splash__face splash__face--back"></span></div>
    </div>
  </div>

  @if (quote) {
    <blockquote class="splash__quote">
      <p class="splash__quote-text">“{{ quote }}”</p>
      @if (quoteAuthor) {
        <footer class="splash__quote-author">— {{ quoteAuthor }}</footer>
      }
    </blockquote>
  }

  <!-- Expands from the book until soft green fills the viewport -->
  <div class="splash__veil" aria-hidden="true"></div>
</div>
